import type { Capitolo } from '../tipi.ts'

const capitolo: Capitolo = {
  id: 'report-esportazioni',
  titolo: 'Report ed esportazioni',
  gruppo: 'Report e gestione',
  permesso: ['report.aggregato', 'export.aggregato'],
  aCheServe: 'La voce «Report» mostra numeri aggregati, mai nomi: beneficiari, interventi, ore, per area, mese, '
    + 'età, genere e comune. Da lì si scarica il riepilogo in Excel.',
  parti: [
    {
      titolo: 'Leggere i report',
      passi: [
        'Apri «Report». Scegli il periodo con «Dal» e «Al» (di solito dall’inizio dell’anno a oggi), poi, se '
          + 'serve, «Area» e «Comune dell’intervento».',
        'In alto leggi i totali; sotto le tabelle per area, mese, fascia d’età, genere e comune.',
        'In «Campi della tipologia» scegli una tipologia per vedere i conteggi delle sue voci.',
      ],
      immagine: {
        file: 'report.webp', larghezza: 1200, altezza: 800,
        descrizione: 'La pagina Report con i filtri, i totali e le tabelle per area e per mese.',
      },
      nota: 'Le celle con pochi beneficiari non si mostrano («sotto soglia: non mostrabile»): un numero piccolo '
        + 'renderebbe riconoscibili le persone.',
    },
    {
      titolo: 'Esportare in Excel',
      permesso: 'export.aggregato',
      passi: [
        'Con i filtri scelti premi «Esporta in XLSX».',
        'Il file non è pronto subito: lo prepara il gestionale. Quando è pronto, arriva la notifica «La tua '
          + 'esportazione è pronta».',
        'Premi «Le mie esportazioni» (o «Vai alle tue esportazioni» nella notifica) e poi «Scarica».',
      ],
      nota: 'Il file resta disponibile sette giorni e lo scarica solo chi l’ha chiesto. Conservalo con cura.',
    },
  ],
  avvertenze: [
    {
      quando: 'L’esportazione è «scaduta» o «non riuscita».',
      cosaFare: 'Chiedila di nuovo dalla pagina «Report».',
    },
    {
      quando: 'Al posto di «Scarica» compare «Chiedi l’approvazione».',
      cosaFare: 'Gli elenchi con nomi oltre 200 righe richiedono il parere di un’altra persona: scrivi perché '
        + 'serve e premi «Chiedi».',
    },
  ],
  vediAnche: ['progetti'],
  parole: ['statistiche', 'numeri', 'excel', 'xlsx', 'esporta', 'scarica', 'rendiconto'],
}

export default capitolo
